module.exports = __webpack_public_path__ + "img/antes_despues_331.a66b1062.png";